var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    stroke: "#A3A2A3",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0591 35.8299C44.2567 35.8299 44.3919 35.8299 44.5374 35.8299C46.1389 35.8299 47.73 35.8299 49.3315 35.8299C50.4339 35.8299 51.2762 36.2786 51.7442 37.3012C52.2122 38.3133 52.025 39.2525 51.297 40.0977C46.4093 45.7533 41.532 51.4194 36.6443 57.0751C35.8332 58.0142 34.6477 58.2542 33.5765 57.7116C32.5262 57.1794 32.0166 56.042 32.3078 54.842C33.1502 51.3881 33.9925 47.9342 34.8453 44.4907C34.8661 44.3864 34.8869 44.2925 34.9181 44.1255C34.7517 44.1255 34.6165 44.1255 34.4813 44.1255C32.8798 44.1255 31.2887 44.1255 29.6872 44.1255C28.5745 44.1255 27.7113 43.6873 27.2433 42.6438C26.7754 41.6107 27.0042 40.6716 27.7425 39.8264C32.547 34.2438 37.3619 28.6612 42.1768 23.0786C42.6136 22.5672 43.1023 22.1707 43.7783 22.0455C45.5566 21.7116 47.1061 23.2664 46.6901 25.0299C46.0141 27.889 45.2966 30.7481 44.5998 33.6073C44.423 34.3273 44.2463 35.0577 44.0591 35.8299ZM35.3444 54.1533C35.3756 54.1638 35.3964 54.1742 35.4276 54.1846C39.8785 49.0299 44.3295 43.8751 48.8428 38.6368C48.614 38.6368 48.4892 38.6368 48.3644 38.6368C46.8357 38.6368 45.2966 38.6473 43.7679 38.6368C42.0208 38.6264 40.8665 37.1655 41.2824 35.4646C41.8856 32.9499 42.52 30.4351 43.1335 27.9203C43.3103 27.2107 43.4871 26.4907 43.6535 25.7812C43.6327 25.7707 43.6015 25.7603 43.5807 25.7394C39.1298 30.9046 34.6685 36.0594 30.1656 41.2873C31.9334 41.2873 33.5973 41.2768 35.2612 41.2873C36.9771 41.2977 38.1315 42.7586 37.7363 44.4386C37.2059 46.6403 36.6547 48.842 36.114 51.0333C35.854 52.0873 35.594 53.1203 35.3444 54.1533Z",
    fill: "#0D0C17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbol);
export default __webpack_public_path__ + "static/media/symbol.83b2ecb6a2b4c3da1039e001bf07c8d2.svg";
export { ForwardRef as ReactComponent };